import { createFileRoute, redirect } from "@tanstack/react-router"
import { ChangeProjectSelection } from "@/features/change-projects/components/ChangeProjectSelection"
import { canManageBulkUpdates } from "@/features/change-projects/core/access"

export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId/select")({
  beforeLoad: ({ context, params }) => {
    if (!canManageBulkUpdates(context.user)) {
      throw redirect({
        to: "/bulk-updates/$changeProjectId/review",
        params: { changeProjectId: params.changeProjectId },
        replace: true,
      })
    }
  },
  component: SelectStep,
})

function SelectStep() {
  const { changeProjectId } = Route.useParams()
  return <ChangeProjectSelection changeProjectId={changeProjectId} />
}
